export default "__VITE_ASSET__DVxCjpt9__"